import { defineComponent as _defineComponent } from 'vue'
import { resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }

import { nextTick, onBeforeUnmount, onMounted, ref, watch } from 'vue';

interface Props {
	html?: string | null;
	unsafe?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'UnsafeHtmlRenderer',
  props: {
    html: { default: '' },
    unsafe: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;

const unsafeContainer = ref<HTMLElement | null>(null);

const decodeHtmlEntities = (value: string) => {
	const decoder = document.createElement('textarea');
	decoder.innerHTML = value;

	return decoder.value;
};

const executeScripts = (container: HTMLElement) => {
	const scripts = Array.from(container.querySelectorAll('script'));

	scripts.forEach((script) => {
		const replacement = document.createElement('script');

		Array.from(script.attributes).forEach((attribute) => {
			replacement.setAttribute(attribute.name, attribute.value);
		});

		replacement.textContent = script.textContent ?? '';
		script.parentNode?.replaceChild(replacement, script);
	});
};

const renderUnsafeHtml = async () => {
	if (!props.unsafe) {
		return;
	}

	await nextTick();

	if (!unsafeContainer.value) {
		return;
	}

	unsafeContainer.value.innerHTML = decodeHtmlEntities(props.html ?? '');
	executeScripts(unsafeContainer.value);
};

watch(
	() => [props.html, props.unsafe],
	() => {
		if (props.unsafe) {
			void renderUnsafeHtml();
			return;
		}

		if (unsafeContainer.value) {
			unsafeContainer.value.innerHTML = '';
		}
	},
	{ immediate: true },
);

onBeforeUnmount(() => {
	if (unsafeContainer.value) {
		unsafeContainer.value.innerHTML = '';
	}
});

onMounted(() => {
	if (props.unsafe) {
		void renderUnsafeHtml();
	}
});

return (_ctx: any,_cache: any) => {
  const _directive_dompurify_html = _resolveDirective("dompurify-html")!

  return (!_ctx.unsafe)
    ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, null, 512)), [
        [_directive_dompurify_html, _ctx.html]
      ])
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        ref_key: "unsafeContainer",
        ref: unsafeContainer
      }, null, 512))
}
}

})